import actions from "./actions";

const initState = {
  listPsm: [],
  psmLoading: false,
  loading: false,
  roles: [],
  grades: [],
  schools: [],
  subjects: [],
  exportData: [],
  userList: null,
  completed: false,
};

export default function psmReducer(state = initState, action) {
  switch (action.type) {
    case actions.PSM_LOADER:
      return {
        ...state,
        psmLoading: action.loading,
      };

    case actions.SET_LOADING:
      return {
        ...state,
        loading: action.loading,
      };

    case actions.FETCH_PSM_CONFIG_SUCCESS:
      return {
        ...state,
        roles: action.roles,
        grades: action.grades,
        schools: action.schools,
        subjects: action.subjects,
      };

    case actions.FETCH_PSM_EXPORT:
      return {
        ...state,
        loading: true,
        exportData: [],
      };

    case actions.FETCH_PSM_EXPORT_SUCCESS:
      return {
        ...state,
        loading: false,
        exportData: action.payload,
      };

    case actions.FETCH_USERLIST:
      return {
        ...state,
        userList: null,
        completed: false,
      };

    case actions.FETCH_USERLIST_SUCCESS:
      return {
        ...state,
        userList: action.users,
      };

    case actions.SAVE_PSM_SUCCESS:
      return {
        ...state,
        completed: true,
      };

    case actions.RESET:
      return {
        ...state,
        psm: null, // note: if "psm" was never in state, this just adds a new key
      };

    case actions.FETCH_PSM_LIST:
      return {
        ...state,
        loading: true,
      };

    case actions.FETCH_PSM_LIST_SUCCESS:
      return {
        ...state,
        listPsm: action.data,
        loading: false,
      };

    default:
      return state;
  }
}
